import { useCallback, useState } from 'react';
export default () => {
  const [initialData, setInitialData] = useState<any>({});
  const [namespaceArr, setNamespaceArr] = useState<string[]>([]);

  //   获取需要筛选的key
  const setInitialObj = (obj: any) => {
    const pathname = window.location.pathname;
    setNamespaceArr((e: string[]) => {
      return [...new Set([...e, pathname])];
    });
    setInitialData(obj);
  };

  type UserListItem = NonNullable<API.GetUserListByFilterResult['data']>['list'];
  // 筛选员工列表 下拉展示在职的员工+本单原本已选择的离职员工+离职可显示的员工（显示状态：开启）
  const filterUserList = useCallback(
    (key?: string, list: UserListItem[] = []): any[] => {
      const newList = list.filter((item: any) => {
        const isQuitOrQuitShow = item.is_quit === 2 || (item.is_quit === 1 && item.quit_show === 1);
        const pathname = window.location.pathname;
        //   判断需不需要回显已选择的
        const isNeedEcho = namespaceArr.includes(pathname);

        const isMatchInitialObjKey =
          key && isNeedEcho
            ? Array.isArray(initialData[key])
              ? initialData[key]?.includes(item.user_id)
              : initialData[key] === item.user_id
            : false;

        return isQuitOrQuitShow || isMatchInitialObjKey;
      });

      return newList;
    },
    [initialData],
  );

  return {
    filterUserList,
    setInitialObj,
  };
};
